import { useEffect, useRef, useState } from "react";

/**
 * Marca um elemento como visível na primeira vez que ele entra na tela.
 *
 * Uma vez só: revelação que refaz a cada rolagem de volta cansa e chama
 * atenção para si mesma em vez de para o conteúdo. Quem pede menos
 * movimento já nasce visível, sem transição nenhuma.
 */
export function useReveal<T extends HTMLElement>(margem = "0px 0px -12% 0px") {
  const ref = useRef<T>(null);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || visivel) return;

    const semMovimento = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (semMovimento || typeof IntersectionObserver === "undefined") {
      setVisivel(true);
      return;
    }

    const obs = new IntersectionObserver(
      (entradas) => {
        if (entradas.some((e) => e.isIntersecting)) {
          setVisivel(true);
          obs.disconnect();
        }
      },
      { rootMargin: margem, threshold: 0.1 },
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [margem, visivel]);

  return { ref, visivel, props: visivel ? { "data-visivel": "" } : {} };
}
